"use strict";

import get from "lodash/get";

import { isUserOnline } from "../../storage/LocalStorage";

export class NetworkError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
  }

  get description() {
    return `${this.code} : ${this.message}`;
  }
};

export class NetworkRequest {
  constructor(options) {
    this.options = options;
  }

  getNetworkRequestOptions() {
    return this.options;
  }

  isNetworkRequest() {
    return true;
  }
};

const getGrpcService = (name) => {
  // Add specific service mappings here when needed
  return null;
};

const convertResponse = (response = {}) => {
  const content = get(response, ["content"], []);
  return {
    error: response.error || 0,
    data: {
      error: response.error || 0,
      content,
    },
  };
};

const Network = (options, queue = false) => {
  return new Promise((resolve, reject) => {
    Network.isConnected()
      .then((connected) => {
        if (!connected) {
          console.error("Network error: No connectivity");
          return reject("No network connectivity");
        }

        const { serviceName, action, params } = options;
        const grpcService = getGrpcService(serviceName);
        if (!grpcService) {
          return reject("Service not found");
        }

        let data = { ...params };
        const objParams = data.parameters ? JSON.parse(data.parameters) : {};
        objParams["isWebRequest"] = true;
        data.parameters = JSON.stringify(objParams);

        grpcService[action](data)
          .then((response) => resolve(convertResponse(response)))
          .catch((err) => {
            console.error("grpcService error in network request:", err);
            reject(err);
          });
      })
      .catch((err) => {
        console.error("Network error:", err);
        reject(err);
      });
  });
};

Network.getNetworkInfo = () => (navigator ? navigator.connection : null);

Network.isWiFi = () => Promise.resolve(true);

Network.isCellular = () => Promise.resolve(true);

Network.addConnectionChangeEventListener = () => {};

Network.removeConnectionChangeEventListener = () => {};

Network.isConnected = () => Promise.resolve(isUserOnline());

Network.isOnline = () => {
  // return QueueServiceClient.isSocketConnected();
};

export function futureRequest(key, networkRequest) {
  throw new Error("Not supported for web requests");
};

export default Network;
